import React from 'react';

import Error401 from './Error401';
import Error403 from './Error403';
import Error404 from './Error404';
import Error500 from './Error500';
import ComingSoon from './ComingSoon';
import Maintenance from './Maintenance';

export const errorPagesConfigs = [
  {
    path: '/errors/401',
    element: <Error401 />,
  },
  {
    path: '/errors/403',
    element: <Error403 />,
  },
  {
    path: '/errors/404',
    element: <Error404 />,
  },
  {
    path: '/errors/500',
    element: <Error500 />,
  },
  {
    path: '/errors/coming-soon',
    element: <ComingSoon />,
  },
  {
    path: '/errors/maintenance',
    element: <Maintenance />,
  },
];
